export const squareGradients = {
    charcoal: require("./Charcoal.jpg"),
    cyanPurple: require("./Cyan-Purple.jpg"),
    cyan: require("./Cyan.jpg"),
    purple: require("./Purple.jpg"),
    redPurple: require("./Red-Purple.jpg"),
    violetCharcoal: require("./Violet-Charcoal.jpg"),
    yellow: require("./Yellow.jpg"),
};
